import {
  getDefaultIdeamCopyProfile,
  getProductCopyProfile,
  IDEAM_ATTRIBUTION_TEXT,
  RAINVIEWER_ATTRIBUTION_TEXT,
  RAINVIEWER_FALLBACK_WARNING,
  RAINVIEWER_SOURCE_LABEL,
  DEFAULT_IDEAM_PRODUCT_IDENTITY,
} from "../utils/ideamProductCopy.js";
import {
  getColombiaLiveRadarLayerLabel,
  getWeatherSourceDisplayName,
  getWeatherSourceMetadata,
} from "./colombiaWeatherSourceMetadata.js";

export const COLOMBIA_IDEAM_SOURCE_KEY = "IDEAM_RADAR_COMPOSITE";
export const COLOMBIA_IDEAM_LAYER_KEY = "CO_IDEAM_RADAR_COMPOSITE";
export const COLOMBIA_IDEAM_DEFAULT_OPACITY = 0.65;

const defaultIdeamCopy = getDefaultIdeamCopyProfile();
const liveRadarMetadata = getWeatherSourceMetadata(COLOMBIA_IDEAM_SOURCE_KEY);

export const COLOMBIA_IDEAM_ATTRIBUTION = IDEAM_ATTRIBUTION_TEXT;
export const COLOMBIA_IDEAM_SOURCE_LABEL = getColombiaLiveRadarLayerLabel();
export const COLOMBIA_IDEAM_SOURCE_LONG_LABEL = defaultIdeamCopy.sourceLongLabel;
export const COLOMBIA_IDEAM_SOURCE_DESCRIPTION =
  liveRadarMetadata?.description || defaultIdeamCopy.sourceDescription;
export const COLOMBIA_IDEAM_LAYER_LABEL = getColombiaLiveRadarLayerLabel();
export const COLOMBIA_IDEAM_LAYER_SUBTITLE = "IDEAM official radar composite";
export const COLOMBIA_IDEAM_LAYER_DESCRIPTION =
  liveRadarMetadata?.description || defaultIdeamCopy.layerControlDescription;
export const COLOMBIA_IDEAM_LAYER_TOGGLE_DESCRIPTION = COLOMBIA_IDEAM_LAYER_SUBTITLE;

export const COLOMBIA_RADAR_EXPERIMENTAL_WARNING = defaultIdeamCopy.experimentalMessage;
export const COLOMBIA_RADAR_FALLBACK_WARNING = RAINVIEWER_FALLBACK_WARNING;

const defaultWarnings = getProductCopyProfile(DEFAULT_IDEAM_PRODUCT_IDENTITY);
export const IDEAM_STALE_WARNING = defaultWarnings.staleWarning;
export const IDEAM_DOWN_WARNING = defaultWarnings.downWarning;
export const IDEAM_UNKNOWN_FRESHNESS_WARNING = defaultWarnings.unknownFreshnessWarning;

export {
  getProductCopyProfile,
  DEFAULT_IDEAM_PRODUCT_IDENTITY,
  RAINVIEWER_ATTRIBUTION_TEXT,
  RAINVIEWER_SOURCE_LABEL,
  RAINVIEWER_FALLBACK_WARNING,
};
